import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

export interface DropDownValues {
  Countries: string[];
  Languages: string[];
}

export interface SearchListEntry {
  productCode: string;
  productName: string;
  countryName: string;
  language: string;
  documentId: string;
  materialCode1: null;
  materialCode2: string;
  docid: string;
  docformat: string;
  doctype: string;
  fileext: string;
  filename: string;
  version: string;
  title: string;
  date:string;
  pdfTitle :string;
  gbuEnterprise: string;
}

export interface SearchList {
  DocumentCount: number;
  TotalCount: number;
  PageCount: number;
  CurrentPage: number;
  DocumentsPerPage: number;
  DocumentsThisPage: number;
  ProductTitle: string;
  Result: {
    Docs: SearchListEntry[];
  };
}

export interface SearchListInput {
  pageNumber: number;
  sinequaProfile: string;
  country: string;
  language: string;
  searchText: string;
  materialValue: string;
  sort: string;
  isFirstTimeSearch : boolean;
}
export interface DocumentDownloadId {
  docId: string;
  productName : string;
  productTitle : string;
  date: string;
  version: string;
  pdfTitle:string;
}

@Injectable({
  providedIn: 'root',
})
export class SDSseachService {
  apiUrl = environment.apiURL;

  constructor(private http: HttpClient) {}

  getDropdownValues(): Observable<DropDownValues> {
    return this.http.get<DropDownValues>(
      `${this.apiUrl}/rest/countryandlanguage/list`
    );
  }
getLanguageDropdown(selectedCountryCode:string): Observable<DropDownValues> {
  return this.http.get<DropDownValues>(
    `${this.apiUrl}/rest/countryandlanguage/list?country=${selectedCountryCode}`
  );
}
  getSearchList(post: SearchListInput): Observable<SearchList> {
    return this.http.post<SearchList>(
      `${this.apiUrl}/rest/sdssearch/list`,
      post
    );
  }

  getSdsDocument(post: DocumentDownloadId): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/rest/download/sds`, post);
  }
  


}
